import { injectTranslate } from '@recruitee/i18n';
import { textCellFactory } from '@recruitee/user-interface';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';

export const candidatesCountColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.CandidatesCount,
  label: injectTranslate()('app.offers.table.candidates_count'),
  visible: true,
  geometry: {
    width: 120,
    minWidth: 120,
    maxWidth: 140,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: textCellFactory('candidatesCount'),
}));
